import React from "react"

const Sidebar = ({ menuItems, activeTab, setActiveTab }) => {
  return (
    <aside className="w-64 border-r border-zinc-800 bg-zinc-950">
      <div className="p-6">
        <h1 className="text-xl font-semibold text-white">Dashboard</h1>
      </div>
      {menuItems.map((item) => (
      <button
          key={item.id}
          onClick={() => {
            localStorage.setItem('last_tab', item.id)
            setActiveTab(localStorage.getItem('last_tab'))
          }}
          className={`w-full mt-2 flex items-center px-6 py-3 text-sm text-zinc-100 border-l-4 
            ${
              activeTab === item.id ? "bg-zinc-800/50 border-teal-500"  : "hover:bg-zinc-800/25 border-transparent"
            }`}
        >
          {item.label}
      </button>
      ))}
    </aside>
  )
}

export { Sidebar }
